
























import moment from 'moment';
import { Vue, Component, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class DimensionForm5 extends Vue {
  @PropSync('dimSyncDefs') syncDimSyncDefs!: any;

  time = moment('00:00:00', 'HH:mm:ss');
  date = moment().format('YYYY-MM-DD');
  type = 0;

  created() {
    this.onSyncDimSyncDefsChange();
  }

  @Watch('syncDimSyncDefs')
  onSyncDimSyncDefsChange() {
    this.date = this.syncDimSyncDefs.jobConfig?.runDateFormat || moment().format('YYYY-MM-DD');
    this.time = this.syncDimSyncDefs.jobConfig?.runDateStr || moment('00:00:00', 'HH:mm:ss');
    this.type = this.syncDimSyncDefs.jobConfig?.rate;
  }

  changeCron() {
    let month = moment(this.date).format('M');
    let day = moment(this.date).format('D');
    let hour = moment(this.time).hour();
    let minute = moment(this.time).minute();
    let second = moment(this.time).second();
    let cron = '';
    if (this.syncDimSyncDefs.jobMode == 1) {
      cron = `${second} ${minute} ${hour} ${day} ${month} ?`;
    }
    if (this.syncDimSyncDefs.jobMode == 2) {
      this.type == 0 && (cron = `${second} ${minute} ${hour} * * ?`);
      this.type == 1 && (cron = `${second} ${minute} * * * ?`);
    }
    this.syncDimSyncDefs.cronExpression = cron;
    this.syncDimSyncDefs.jobConfig = {
      rate: this.type,
      runDateFormat: moment(this.date).format(),
      runDateStr: moment(this.time).format()
    };
  }
}
